<template>
  <div>
    <div class="main-title">应付账款</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-input
              placeholder="搜索单据编号、教练"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              style="width:220px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.fin_item"
              placeholder="项目"
              style="width:150px"
              @change="search(searchParams)">
              <el-option label="全部项目" value=""></el-option>
              <el-option label="仓埠科二押金" value="仓埠科二押金"></el-option>
              <el-option label="仓埠科三押金" value="仓埠科三押金"></el-option>
              <el-option label="大车科二押金" value="大车科二押金"></el-option>
              <el-option label="大车科三押金" value="大车科三押金"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.is_pay"
              filterable
              placeholder="状态"
              style="width:120px"
              @change="search(searchParams)">
              <el-option label="全部状态" value=""></el-option>
              <el-option label="未支付" value="0"></el-option>
              <el-option label="已支付" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="支出日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-button style="margin-bottom:10px" v-if="selectRows.length > 0 && selectRows[0].is_pay == 0" @click="batEdit">批量支出({{selectRows.length}})</el-button>
      <el-button style="margin-bottom:10px" v-if="selectRows.length > 0 && selectRows[0].is_pay == 1" @click="multiPrint">打印单据({{selectRows.length}})</el-button>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        :summary-method="getSummaries"
        show-summary
        @selection-change="handleSelectionChange"
        style="width:100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column
          prop="id"
          label="系统编号"
          width="80">
        </el-table-column> -->
        <el-table-column
          prop="bill_id"
          label="单据编号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fin_item"
          label="项目"
          width="160">
        </el-table-column>
        <el-table-column
          prop="fin_money"
          label="金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="驾校"
          width="80">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="80">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_time"
          label="支出时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="pay_oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="return_money"
          label="账单金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="return_rate"
          label="返现率"
          width="80">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" :disabled="scope.row.is_pay == 1" @click="edit(scope.row)">支出</el-button>
            <el-button type="text" v-if="scope.row.is_pay == 1" @click="print(scope.row)">打印</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 支出 -->
    <el-dialog title="新增支出" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="120px">
        <el-form-item label="支出项目">
          <el-col :span="11">
            <el-input v-model="form.fin_item" disabled></el-input>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-input v-model="form.fin_no" placeholder="凭证号(可以不填)" style="width:100%"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="金额">
          <el-col :span="13" style="text-align:center;">
            {{ form.return_money }} X
            <el-select v-model="form.return_rate" @change="rateChange" style="width:80px">
              <el-option label="10%" value="0.10"></el-option>
              <el-option label="30%" value="0.30"></el-option>
              <el-option label="35%" value="0.35"></el-option>
              <el-option label="38%" value="0.38"></el-option>
              <el-option label="40%" value="0.40"></el-option>
            </el-select>
            = {{ form.fin_money }}
          </el-col>
          <el-col :span="11">
            <el-input v-model="form.fin_person" disabled></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-col :span="11">
            <el-select v-model="form.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:100%">
              <el-option label="现金" value="现金"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="微信支付" value="微信支付"></el-option>
              <el-option label="刷卡" value="刷卡"></el-option>
              <el-option label="转账" value="转账"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-form-item prop="fin_account">
              <el-select v-model="form.fin_account" placeholder="请选择账户" style="width:100%">
                <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" autosize></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formCommit" :loading="formCommiting">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 批量支出 -->
    <el-dialog title="批量支出" :visible.sync="batFormVisible">
      <el-form :model="batForm" ref="batForm" :rules="batFormRules" label-width="120px">
        <el-form-item label="已选择的单据">
          {{ selectRows.map(r => r.bill_id).join(',') }}
        </el-form-item>
        <el-form-item label="支出项目">
          <el-col :span="11">
            <el-input v-model="batForm.fin_item" disabled></el-input>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-input v-model="batForm.fin_no" placeholder="凭证号(可以不填)" style="width:100%"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="金额">
          <el-col :span="13" style="text-align:center;">
            {{ batForm.return_money }} X
            <el-select v-model="batForm.return_rate" @change="rateChange" style="width:80px">
              <el-option label="10%" value="0.10"></el-option>
              <el-option label="30%" value="0.30"></el-option>
              <el-option label="35%" value="0.35"></el-option>
              <el-option label="38%" value="0.38"></el-option>
              <el-option label="40%" value="0.40"></el-option>
            </el-select>
            = {{ batForm.fin_money }}
          </el-col>
          <el-col :span="11">
            <el-input v-model="batForm.fin_person" disabled></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-col :span="11">
            <el-select v-model="batForm.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:100%">
              <el-option label="现金" value="现金"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="微信支付" value="微信支付"></el-option>
              <el-option label="刷卡" value="刷卡"></el-option>
              <el-option label="转账" value="转账"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-form-item prop="fin_account">
              <el-select v-model="batForm.fin_account" placeholder="请选择账户" style="width:100%">
                <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="batForm.remark" type="textarea" autosize></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batFormCommit" :loading="batFormCommiting">确 定</el-button>
        <el-button @click="batFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'fin_payable',
      searchForm: {
        query: '',
        is_pay: null,
        daterange: [],
        fin_item: null,
      },
      form: {
        id: 0,
        fin_type: '0',
        fin_item: '',
        pay_type: '现金',
        fin_account: 0,
        fin_money: 0,
        fin_person: '',
        fin_no: '',
        remark: '',
        return_money: 0,
        return_rate: 0
      },
      formRules: {
        fin_account: [
          { required: true, message: '请选择账户', trigger: 'blur' }
        ]
      },
      formVisible: false,
      formCommiting: false,
      batForm: {
        ids: [],
        fin_type: '0',
        fin_item: '',
        pay_type: '现金',
        fin_account: 0,
        fin_money: 0,
        fin_person: '',
        fin_no: '',
        remark: '',
        return_money: 0,
        return_rate: 0
      },
      batFormRules: {
        fin_account: [
          { required: true, message: '请选择账户', trigger: 'blur' }
        ]
      },
      batFormVisible: false,
      batFormCommiting: false,
      accountList: []
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      let params = { ...this.searchForm }
      if (this.searchForm.daterange && this.searchForm.daterange.length > 0) {
        params = {
          query: this.searchForm.query,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59',
          is_pay: this.searchForm.is_pay,
          fin_item: this.searchForm.fin_item,
        }
      }
      return params
    },
    accountListFilter () {
      let pay_type =  this.form.pay_type
      if (this.batFormVisible) {
        pay_type = this.batForm.pay_type
      }
      if (pay_type == '现金') {
        return this.accountList.filter(i => i.account_type === '现金')
      } else if (pay_type === '支付宝') {
        return this.accountList.filter(i => i.account_type === '支付宝')
      } else if (pay_type === '微信支付') {
        return this.accountList.filter(i => i.account_type === '微信')
      } else if (pay_type === '刷卡') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else if (pay_type === '转账') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else {
        return []
      }
    }
  },
  mounted () {
    this.fetchAccountList()
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (!row.is_pay) {
        return ''
      } else {
        return 'row-green'
      }
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property == 'fin_money' || column.property == 'return_money') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'fin_item') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    fetchAccountList () {
      this.$http.get('/dbapi/fin_account_combo').then(response => {
        if (response.data.success) {
          this.accountList = response.data.list
          for (var i = 0; i < this.accountList.length; i++) {
            if (this.accountList[i].account_type === '现金') {
              this.form.fin_account = this.accountList[i].id
              this.batForm.fin_account = this.accountList[i].id
              break
            }
          }
        }
      })
    },
    payTypeChange () {
      if (this.accountListFilter.length > 0) {
        this.form.fin_account = this.accountListFilter[0].id
        this.batForm.fin_account = this.accountListFilter[0].id
      }
    },
    rateChange () {
      if (this.formVisible) {
        this.form.fin_money = Math.floor(this.form.return_money * parseFloat(this.form.return_rate))
      }
      if (this.batFormVisible) {
        this.batForm.fin_money = Math.floor(this.batForm.return_money * parseFloat(this.batForm.return_rate))
      }
    },
    edit (row) {
      this.form.id = row.id
      this.form.fin_item = row.fin_item
      this.form.fin_money = row.fin_money
      this.form.fin_person = row.fin_person
      this.form.remark = row.remark
      this.form.return_money = row.return_money
      this.form.return_rate = row.return_rate
      this.formVisible = true
    },
    formCommit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formCommiting = true
          this.$http.post('/dbapi/fin_payable_pay', this.form).then(response => {
            this.formCommiting = false
            if (response.data.success) {
              this.$refs.form.resetFields()
              this.formVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.$confirm('是否要现在打印支出证明单?', '提示', {
                confirmButtonText: '现在打印',
                cancelButtonText: '稍后打印',
                type: 'warning'
              }).then(() => {
                let url = '/expend_print'
                if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
                  url = '/expend_print_1'
                }
                if ([2, 8].indexOf(this.user.group_id) >= 0) {
                  url = '/expend_print_blank'
                }
                window.open(this.$http.receiptBaseUrl + url + '?id=' + response.data.insertId + '&token=' + localStorage.getItem('kaochang.token'))
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    batEdit () {
      let row = this.selectRows[0]
      let fin_money = 0
      let return_money = 0
      let remark = '单据编号:'
      this.selectRows.forEach(i => {
        fin_money += parseInt(i.fin_money)
        return_money += parseInt(i.return_money)
        remark = remark + i.bill_id + ','
      })
      this.batForm.ids = this.selectRows.map(i => i.id)
      this.batForm.fin_item = row.fin_item
      this.batForm.fin_money = fin_money
      this.batForm.fin_person = row.fin_person
      this.batForm.remark = remark
      this.batForm.return_money = return_money
      this.batForm.return_rate = row.return_rate
      this.batFormVisible = true
    },
    batFormCommit () {
      this.$refs.batForm.validate(valid => {
        if (valid) {
          this.batFormCommiting = true
          this.$http.post('/dbapi/fin_payable_bat', this.batForm).then(response => {
            this.batFormCommiting = false
            if (response.data.success) {
              this.$refs.batForm.resetFields()
              this.batFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.$confirm('是否要现在打印支出证明单?', '提示', {
                confirmButtonText: '现在打印',
                cancelButtonText: '稍后打印',
                type: 'warning'
              }).then(() => {
                let url = '/expend_print'
                if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
                  url = '/expend_print_1'
                }
                if ([2, 8].indexOf(this.user.group_id) >= 0) {
                  url = '/expend_print_blank'
                }
                window.open(this.$http.receiptBaseUrl + url + '?id=' + response.data.insertId + '&token=' + localStorage.getItem('kaochang.token'))
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    print (row) {
      let url = '/expend_print'
      if ([2, 8].indexOf(this.user.group_id) >= 0) {
        url = '/expend_print_blank'
      }
      if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
        url = '/expend_print_1'
      }
      window.open(this.$http.receiptBaseUrl + url + '?token=' + localStorage.getItem('kaochang.token') + '&id=' + row.fin_id)
    },
    multiPrint () {
      let ids = ''
      for (var i = 0; i < this.selectRows.length; i++) {
        if (this.selectRows[i].fin_id > 0) {
          ids += '&ids=' + this.selectRows[i].fin_id
        }
      }
      let url = '/expend_print'
      if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
        url = '/expend_print_1'
      }
      if ([2, 8].indexOf(this.user.group_id) >= 0) {
        url = '/expend_print_blank'
      }
      window.open(this.$http.receiptBaseUrl + url + '?token=' + localStorage.getItem('kaochang.token') + ids)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/finance/Payable.vue